module.exports = __webpack_public_path__ + "img/icon-close-round.2da5b648.svg";